document.addEventListener('DOMContentLoaded', () => {

  if (!window.location.pathname.includes('/products/sample-item-bravo')) return;

  // Car Make → Model → Available Years
  const carData = {
    "Ford": {
      "Ranger": [2016, 2017, 2018, 2019, 2020, 2021],
      "Focus": [2005, 2006, 2007, 2008, 2009, 2010, 2011],
      "Everest": [2015, 2016, 2017, 2018, 2019, 2020, 2021]
    },
    "Holden": {
      "Cruze": [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016],
      "Colorado": [2014, 2015, 2016]
    },
    "Hyundai": {
      "Tucson": [2015, 2016, 2017, 2018],
      "Getz": [2002, 2003, 2004, 2005],
      "iX35": [2009, 2010, 2011, 2012, 2013, 2014, 2015],
      "Santa Fe": [2006, 2007, 2008, 2009, 2010, 2011, 2012],
      "Accent": [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020],
      "iLoad": [2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015],
      "iMax": [2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015]
    },
    "Mazda": {
      "BT-50": [2006, 2007, 2008, 2009, 2010, 2011],
      "Mazda 2": [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014],
      "Mazda 3": [2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013]
    },
    "Mercedes": {
      // "A-Class": [2005, 2006, 2007, 2008, 2009, 2010, 2011],
      // "B-Class": [2005, 2006, 2007, 2008, 2009, 2010, 2011],
      // "Sprinter": [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018],
      // "Viano": [2008, 2009, 2010, 2011],
      // "Vito": [2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014]
      "A-Class": [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018],
      "B-Class": [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018],
      "Sprinter": [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018],
      "Viano": [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018],
      "Vito": [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018]
    },
    "Mitsubishi": {
      "Lancer": [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017],
      "Triton": [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018],
      "Outlander": [2007, 2008, 2009, 2010, 2011, 2012],
      "ASX": [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
      "Citroen": [2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012]
    },
    "Peugeot": {
      "4007": [2009, 2010, 2011, 2012, 2013],
    },
    "Subaru": {
      "WRX": [2014, 2015],
      "Forester": [2013, 2014],
      "Impreza": [2012, 2013, 2014],
      "XV": [2012, 2013, 2014, 2015]
    },
    "Suzuki": {
      "Swift": [2011, 2012, 2013, 2014, 2015, 2016, 2017]
    },
    "Toyota": {
      "Camry": [2006, 2007, 2008, 2009, 2010, 2011],
      "Yaris": [2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
      "RAV4": [2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017],
      "Land Cruiser 70 Series": [2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
      "Land Cruiser 100": [2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
      "Land Cruiser 200": [2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
      "Land Cruiser 200 Series": [2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
      "Prado": [2013, 2014, 2015, 2016, 2017],
      "Kluger": [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
      "Kluger Grande": [2007, 2008, 2009, 2010, 2011, 2012, 2013],
      "Hilux": [2011]
    },
    "Volkswagen": {
      "Crafter": [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020],
      "Amarok": [2011, 2012, 2013, 2014, 2015, 2016],
      "Beetle": [2012, 2013, 2014],
      "Caddy": [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015],
      "Multivan": [2016, 2017, 2018, 2019],
      "Tiguan": [2015, 2016],
      "Transporter": [2016, 2017, 2018, 2019],
    }
  };

  const makeSelect = document.getElementById("car-make");
  const modelSelect = document.getElementById("car-model");
  const yearSelect = document.getElementById("car-year");
  const kitLinkWrapper = document.getElementById("kit-link-wrapper");
  const kitLink = document.getElementById("kit-link");

  makeSelect.addEventListener("change", () => {
    const selectedMake = makeSelect.value;
    const models = carData[selectedMake] ? Object.keys(carData[selectedMake]) : [];

    modelSelect.innerHTML = `<option value="" disabled selected>Select Model</option>`;
    models.forEach(model => {
      const option = document.createElement("option");
      option.value = model;
      option.textContent = model;
      modelSelect.appendChild(option);
    });

    modelSelect.disabled = models.length === 0;
    yearSelect.disabled = true;
    yearSelect.innerHTML = `<option value="" disabled selected>Select Year</option>`;
    updateKitLink();
  });

  modelSelect.addEventListener("change", () => {
    const selectedMake = makeSelect.value;
    const selectedModel = modelSelect.value;
    const years = carData[selectedMake] && carData[selectedMake][selectedModel] ? carData[selectedMake][selectedModel] : [];

    yearSelect.innerHTML = `<option value="" disabled selected>Select Year</option>`;
    years.forEach(year => {
      const option = document.createElement("option");
      option.value = year;
      option.textContent = year;
      yearSelect.appendChild(option);
    });

    yearSelect.disabled = years.length === 0;
    updateKitLink();
  });

  yearSelect.addEventListener("change", updateKitLink);

  function updateKitLink() {
    const make = makeSelect.value;
    let model = modelSelect.value;
    const year = yearSelect.value;
    let enableYearParam = true;
    let enableModelParam = true;

    // Special case to match endpoint filter
    if (model === "Mazda 3") model = "3";
    if (model === "Mazda 2") model = "2";

    // for models with different filter value/format in store collections
    const specialModels = {
      "Land Cruiser 70 Series": "Landcruiser+70+Series",
      "Land Cruiser 100": "Landcruiser+100",
      "Land Cruiser 200": "Landcruiser+200",
      "Land Cruiser 200 Series": "Landcruiser+200+Series",
      "Kluger Grande": "Kluger+Grande",
      "Yaris": "Yaris+Sedan"
    };

    //generate correct collections url with filter that does not have models
    const excludeModels = ["Crafter",  "Amarok",  "Beetle",  "Caddy",  "Multivan",  "Tiguan",  "Transporter", "WRX", "Forester", "Impreza", "XV", "A-Class", "B-Class", "Sprinter", "Viano", "Vito"];

    if (specialModels[model]) {
      model = specialModels[model];
      enableYearParam = false;
    }

    if (excludeModels.includes(model)) {
      enableModelParam = false;
    }


    if (make && model && year) {
      const encodedMake = encodeURIComponent(make);
      const encodedModel = encodeURIComponent(model).replace(/%2B/g, '+');
      const encodedYear = encodeURIComponent(year);
    
      let url = `/collections/headunits?sort_by=&filter.v.price.gte=0&filter.v.price.lte=2799&filter.p.m.custom.make=${encodedMake}`;

      if (enableModelParam) {
        url += `&filter.p.m.custom.model=${encodedModel}`;
      }
      
      if (enableYearParam) {
        url += `&filter.p.m.custom.year=${encodedYear}`;
      }
      
      kitLink.href = url;
      kitLinkWrapper.style.display = "block";
    } else {
      kitLinkWrapper.style.display = "none";
    }
  }
  
});


document.addEventListener('DOMContentLoaded', () => {
  
  function checkUpdateFAQSection() {
      // Check if we're on a collection page
      if (!window.location.pathname.startsWith('/collections/')) {
          return;
      }
  
      // Get the specific section
      const section = document.querySelector('#shopify-section-template--18069666005085__d_rich_text_Gw7AxQ');
      
      if (section) {
          // Find all hero-items within the section
          const heroItems = section.querySelectorAll('.\\#hero-item');
          
          // Check if we have at least 2 hero-items
          if (heroItems.length >= 2) {
              const firstHeroItem = heroItems[0];
              const secondHeroItem = heroItems[1];
              
              // Find the rte-block within the second hero-item
              const rteBlock = secondHeroItem.querySelector('.\\#rte-block');
              
              if (rteBlock) {
                  // Check if rte-block is empty (no content or elements)
                  const isEmpty = !rteBlock.children.length && !rteBlock.textContent.trim();
                  
                  // If RTE block is NOT empty, hide the first hero-item
                  if (isEmpty) {
                      firstHeroItem.style.display = 'none';
                      console.log('First hero-item hidden on collection page');
                  }
              }
          }
      }
  }

  if (window.location.pathname.startsWith('/collections/')) {
    checkUpdateFAQSection();
  }
  
});

document.addEventListener("DOMContentLoaded", function () {
  const forcedIds = new Set([
    // "7835082981469",
    // "7835443855453",
    // "7835443888221",
    // "7835380547677"


    // "7833836879965",
    // "7833836978269",
    // "7833837011037",
    // "7833836945501",
    // "7833837043805",
    // "7833809092701",

    // "7834950729821",
    // "7835432845405",
    // "7833836748893",
    // "7833836781661",
    // "7834950598749",
    // "7834950697053",
    // "7833760923741",
    // "7944728445021",
    // "7835044741213",
    // "7833755648093",
    // "7833763676253",
    // "7833768722525",
    // "7833754009693",
    // "7835431993437",
    // "7835430584413",
    // "7835431567453",
    // "7835430486109",
    // "7834944864349",
    // "7835045855325",

  ]);

  function isAddToCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = form.getAttribute("action") || "";
    if (/\/cart\/add(\.js)?/i.test(action)) return true;
    if (form.querySelector('input[name="id"]')) return true;
    if (form.closest("product-form")) return true;
    return false;
  }

  function getQtyInputForForm(form) {
    // 1) Try inside the form
    let input = form.querySelector('input[name="quantity"]');
    if (input) return input;

    // 2) Fallback: any quantity input whose DOM .form points to this form
    const allQtyInputs = document.querySelectorAll('input[name="quantity"]');
    input = Array.from(allQtyInputs).find(inp => inp.form === form);
    if (input) return input;

    // 3) Last resort: if form has an id, find inputs with matching [form="..."]
    const formId = form.getAttribute('id');
    if (formId) {
      input = document.querySelector(`input[name="quantity"][form="${formId}"]`);
      if (input) return input;
    }
    return null;
  }

  function applyX2(form) {
    const qtyInput = getQtyInputForForm(form);
    if (!qtyInput) { console.log("[x2] no qty input"); return; }

    const productId =
      qtyInput.dataset.productId ||
      qtyInput.getAttribute("data-product-id") ||
      qtyInput.getAttribute("product-id");

    if (!productId || !forcedIds.has(String(productId))) { console.log("[x2] not in forced list"); return; }
    if (qtyInput.dataset.x2Applied === "true") { return; }

    const current = parseInt(qtyInput.value || "1", 10);
    if (!Number.isFinite(current) || current <= 0) return;

    qtyInput.value = String(current * 2);
    qtyInput.dataset.x2Applied = "true";
    console.log("[x2] applied ×2 ->", qtyInput.value);
  }

  // Capture real submits
  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (!isAddToCartForm(form)) return;
    applyX2(form);
  }, true);

  // Catch click-driven add-to-cart
  document.addEventListener("click", function (e) {
    const submitter = e.target.closest('button[type="submit"],input[type="submit"],button[name="add"],button[data-add-to-cart],.product-form__submit');
    if (!submitter) return;
    const form = submitter.form || submitter.closest("form");
    if (!form || !isAddToCartForm(form)) return;
    applyX2(form);
  }, true);

  // Guard programmatic submits too
  const origSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (isAddToCartForm(this)) applyX2(this);
    return origSubmit.call(this);
  };
  const origRequestSubmit = HTMLFormElement.prototype.requestSubmit;
  if (origRequestSubmit) {
    HTMLFormElement.prototype.requestSubmit = function (submitter) {
      if (isAddToCartForm(this)) applyX2(this);
      return origRequestSubmit.call(this, submitter);
    };
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // ✅ Only these VARIANT IDs will be forced to add x2
  const forcedVariantIds = new Set([
    // "43059870498909",
    // "43060506525789",
    // "43060506558557",
    // "43060419788893",
  ]);

  // Optional: customize the quantity applied on collections (default = 2)
  const COLLECTION_ADD_QTY = 2;

  // Intercept collection "Add to cart" buttons inside <product-to-cart>
  document.addEventListener("click", function (e) {
    const btn = e.target.closest('[data-element="to-cart-button"]');
    if (!btn) return;

    const ptc = btn.closest("product-to-cart");
    if (!ptc) return; // not a collection quick-add card

    // Variant id lives on the wrapper
    const variantId = ptc.getAttribute("variant-id");
    if (!variantId || !forcedVariantIds.has(String(variantId))) return; // not in the forced list → let theme handle it

    // We’ll handle it: stop the component’s default JS
    e.preventDefault();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    // Basic UX lock
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");
    // btn.innerText = `Adding ×${COLLECTION_ADD_QTY}…`;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: COLLECTION_ADD_QTY })
    })
    .then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)))
    .then(() => {
      // Notify common cart listeners (varies by theme)
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));

      // Light feedback
      // btn.innerText = `Added ×${COLLECTION_ADD_QTY}`;
      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
      }, 900);
    })
    .catch(err => {
      console.error("[collections x2] add failed", err);
      // Fallback: restore button; optionally let default handler proceed
      btn.innerHTML = originalHTML;
      btn.disabled = false;
      btn.removeAttribute("aria-busy");
      // If you want to fall back to the component’s default behavior on failure:
      // ptc.click && ptc.click();
    });
  }, true); // capture so we pre-empt component internals
});

function initCountdown() {
  // Clear any existing interval to prevent duplicates
  if (window.countdownInterval) {
    clearInterval(window.countdownInterval);
  }
  
  function updateCountdown() {
    // Re-query badges each time to catch newly added ones
    const countdownBadges = document.querySelectorAll('.sale-countdown-badge');
    
    countdownBadges.forEach(badge => {
      const endTimestamp = parseInt(badge.dataset.endDate) * 1000;
      const timerElement = badge.querySelector('.countdown-timer');
      
      if (!timerElement || !endTimestamp || isNaN(endTimestamp)) {
        return;
      }
      
      const now = new Date().getTime();
      const distance = endTimestamp - now;
      
      if (distance < 0) {
        badge.style.display = 'none';
        return;
      }
      
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      let countdownText = '';
      
      if (days > 0) {
        countdownText = `${days}d ${hours}h`;
      } else if (hours > 0) {
        countdownText = `${hours}h ${minutes}m`;
      } else if (minutes > 0) {
        countdownText = `${minutes}m ${seconds}s`;
      } else {
        countdownText = `${seconds}s`;
      }
      
      timerElement.textContent = countdownText;
    });
  }
  
  // Update immediately
  updateCountdown();
  
  // Update every second
  window.countdownInterval = setInterval(updateCountdown, 1000);
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initCountdown);

// Watch for dynamically loaded content
const countdownObserver = new MutationObserver(function(mutations) {
  let shouldReinit = false;
  
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('sale-countdown-badge')) {
            shouldReinit = true;
          } else if (node.querySelector && node.querySelector('.sale-countdown-badge')) {
            shouldReinit = true;
          }
        }
      });
    }
  });
  
  if (shouldReinit) {
    initCountdown();
  }
});

// Start observing
if (document.body) {
  countdownObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// document.addEventListener('DOMContentLoaded', function() {
//   const countdownBadges = document.querySelectorAll('.sale-countdown-badge');
  
//   function updateCountdown() {
//     countdownBadges.forEach(badge => {
//       const endTimestamp = parseInt(badge.dataset.endDate) * 1000;
//       const timerElement = badge.querySelector('.countdown-timer');
      
//       const now = new Date().getTime();
//       const distance = endTimestamp - now;
      
//       if (distance < 0) {
//         badge.style.display = 'none';
//         return;
//       }
      
//       const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//       const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
//       let countdownText = '';
      
//       if (days > 0) {
//         countdownText = `${days}d ${hours}h`;
//       } else if (hours > 0) {
//         countdownText = `${hours}h ${minutes}m`;
//       } else if (minutes > 0) {
//         countdownText = `${minutes}m ${seconds}s`;
//       } else {
//         countdownText = `${seconds}s`;
//       }
      
//       timerElement.textContent = countdownText;
//     });
//   }
  
//   // Update immediately
//   updateCountdown();
  
//   // Update every second
//   setInterval(updateCountdown, 1000);
// });

// document.addEventListener('DOMContentLoaded', () => {

//   if (window.location.pathname.includes('/products/mock-product-echo'))
//   {
//     // This code will run after the HTML is fully parsed
//     setTimeout(() => {
//         console.log('RDCaisip :: Form embed is now visible!');

//         const formEmbed = document.getElementById('app-embed-container-656270');

//         if (formEmbed) {
//             console.log('RDCaisip :: Form embed is now visible!');
//             // The element is now available, so this will work
//             formEmbed.style.setProperty('display', 'block', 'important');

//             const button = document.createElement("button");

//             // Add text
//             button.textContent = "Book Installation";

//             // Add the unusual class name
//             button.setAttribute("class", "book-installation-btn #button @tier:primary @display-style:solid");

//             // Add inline CSS
//             button.style.marginTop = "10px";

//             // Insert it into the page — for example, before your special div
//             const target = document.querySelector('.\\#price');
//             if (target) {
//               target.after(button);
//             }

//             // Add event listener to show form on click
//             // button.addEventListener("click", () => {
//             //   formEmbed.style.setProperty('display', 'block', 'important');
//             //   console.log('Form embed is now visible!');
//             // });
 

//             console.log('RDCaisip :: Form embed is now visible!');
//         } else {
//             // This will help you confirm that the element is the issue
//             console.log('RDCaisip :: Element with ID "app-embed-container-656270" not found.'); 
//         }
//     }, 5000);
//   }


  // document.body.addEventListener("click", (event) => {
  //   // Check if the clicked element is your button
  //   if (event.target.matches(".book-installation-btn")) {

  //       const tmpForm = document.getElementById('app-embed-container-656270');
  //       if (tmpForm) {
  //         tmpForm.style.setProperty("display", "block", "important");
  //         console.log("Form embed is now visible!!!!!");
  //       }
  //   }
  // });

// });

// document.body.addEventListener("click", (event) => {
//   if (event.target.matches(".book-installation-btn")) {
//     console.log('RDCaisip :: Form embed is now visible!');
//     const container = document.getElementById("app-embed-container-656270");
//     if (container) {
//       console.log('RDCaisip :: Form embed is now visible!');
//       // Override the stylesheet's display:none!important
//       container.style.setProperty("display", "block", "important");
//       console.log("RDCaisip :: Form embed container is now visible!!");
//     }
//   }
// });